const inrFormatter = new Intl.NumberFormat("en-IN");

export const formatInr = (n) => inrFormatter.format(Math.abs(Math.round(n)));

// "2026-04-02" -> "02 Apr 2026"; returns the original string if unparseable.
export const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// "2026-04-02" -> "02-Apr-2026"; returns the original string if unparseable.
export const formatDateDash = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .replace(/ /g, "-");
};

export const CONNECTION_STATUS_META = {
  ONGOING: { label: "Ongoing", color: "#3f9d6d" },
  ACTIVE: { label: "Active", color: "#3f9d6d" },
  COMPLETED: { label: "Completed", color: "#3a6ea8" },
  TERMS_INITIATED: { label: "Terms Initiated", color: "#e0952f" },
  TERMS_ACCEPTED: { label: "Terms Accepted", color: "#e0952f" },
};

export const connectionStatusMeta = (status) =>
  CONNECTION_STATUS_META[status] || {
    label: status
      ? status.replace(/_/g, " ").replace(/\w\S*/g, (w) => w[0] + w.slice(1).toLowerCase())
      : "—",
    color: "#8a95a5",
  };

export const signed = (n) => {
  if (!n) return "NIL";
  const sign = n > 0 ? "+" : "−"; // + or − (minus sign)
  return `${sign}${formatInr(n)}`;
};

export const STATUS_META = {
  RECONCILED: { label: "Reconciled", color: "#3f9d6d" },
  BALANCE_LEFT: { label: "Balance Left", color: "#e0952f" },
  DRAWAL_PENDING: { label: "Drawal Pending", color: "#2e6b6b" },
  OVER_DRAWN: { label: "Over-Drawn", color: "#d1584f" },
};

export const STATUS_ORDER = [
  "RECONCILED",
  "BALANCE_LEFT",
  "DRAWAL_PENDING",
  "OVER_DRAWN",
];
